export function richTextPlainText(html: string | null): string {
    if (!html) {
        return ''
    }
    const document = new DOMParser().parseFromString(html, 'text/html')
    document.querySelectorAll('script, style').forEach(element => element.remove())
    return document.body.textContent?.trim() ?? ''
}

export function truncateRichTextHtml(html: string, characterLimit: number): string {
    if (richTextPlainText(html).length <= characterLimit) {
        return html
    }

    const sourceDocument = new DOMParser().parseFromString(html, 'text/html')
    const targetDocument = document.implementation.createHTMLDocument('')
    const state = {
        remaining: characterLimit,
        truncated: false,
    }

    sourceDocument.body.childNodes.forEach(child => {
        const truncatedChild = cloneTruncatedNode(child, targetDocument, state)
        if (truncatedChild) {
            targetDocument.body.appendChild(truncatedChild)
        }
    })

    return targetDocument.body.innerHTML
}

function cloneTruncatedNode(
    node: Node,
    targetDocument: Document,
    state: { remaining: number, truncated: boolean }
): Node | null {
    if (state.truncated) {
        return null
    }

    if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent ?? ''
        if (text.length <= state.remaining) {
            state.remaining -= text.length
            return targetDocument.createTextNode(text)
        }

        state.truncated = true
        const truncatedText = text.slice(0, state.remaining).trimEnd()
        return targetDocument.createTextNode(`${truncatedText}...`)
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
        return null
    }

    const clone = targetDocument.importNode(node, false)
    node.childNodes.forEach(child => {
        const truncatedChild = cloneTruncatedNode(child, targetDocument, state)
        if (truncatedChild) {
            clone.appendChild(truncatedChild)
        }
    })

    return clone
}
